import { featureToggles, isApp } from '@otto-ec/eprivacy-shared'
import { trackingService } from './singletons'
import { LOAD_CB_LAZY_TOGGLE } from './core'

const isWeb = !isApp()

if (isWeb) {
  void trackingService.trackOTConsentDecisionPageImpression()
}
if (isWeb || !featureToggles('cb_no_load_in_app_context', false)) {
  const isLoadCbLazyEnabled = featureToggles(LOAD_CB_LAZY_TOGGLE, false)
  if (isLoadCbLazyEnabled) {
    void import('./bootstrap-lazy').then(({ bootstrapLazy }) =>
      bootstrapLazy(trackingService)
    )
  } else {
    void import('./bootstrap').then(({ bootstrap }) =>
      bootstrap(trackingService)
    )
  }
}
